import { Component, Prop } from 'vue-property-decorator';
import * as tsx from 'vue-tsx-support';
import router from '@/router';
import Log from '@/components/Log';

interface IActivityView {
  src?: string
}

@Component
export default class Activity extends tsx.Component<IActivityView> {
  
  @Prop({default: './8/index.html'}) public src?: string
  
  mounted () {
    window.addEventListener('message', this.onMessage);
  }
  
  onMessage (event: any) {
     if (event.origin === window.location.origin && event.data.state === false) {
      router.push({path: '404'})
    }
  }
  
  render() {
    return (
      <div>
        <Log type='hooks' number='A060' />
        <iframe style="height: 100vh;width: 100vw" src={this.$props.src} name='iframe'/>
      </div>
    )
  }
  
}